import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import dayjs from "dayjs";
import { Field, Form, Formik } from "formik";
import _ from "lodash";
import { observer } from "mobx-react";
import {
  ChangeEvent,
  ChangeEventHandler,
  useCallback,
  useEffect,
  useState,
} from "react";
import { Button } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { DATE_FORMAT } from "../../constants/constants";
import userTypeEnum from "../../constants/enums/user-type-enum";
import { useStore } from "../../contexts/store-provider";
import { getEffectiveMonthYear } from "../../helpers/date-time-helper";
import {
  getHeadquarterIdFromLocalStorage,
  getStoreIdFromLocalStorage,
  getUserTypeFromLocalStorage,
} from "../../helpers/localstorage-helper";
import FormikFormSelect from "../../shared-components/FormikFormHandlers/FormikFormSelect";
import FormikMonthYearFieldMUI from "../../shared-components/FormikFormHandlers/FormikMonthYearFieldMUI";
import { monthLyTotallingFilterSchema } from "../../shared-components/FormikFormHandlers/FormikValidationSchema";
import FormLoader from "../../shared-components/FormLoader/FormLoader";
import DropdownInput from "../../shared-components/input/DropdownInput";
import LanguageSlider from "../../shared-components/language-slider/language-slider";
import ShowPopupHOC from "../../shared-components/popup/show/show-popup-hoc";
import { formatMessage } from "../../translations/format-message";
import CustomerDailySalesAccToAgeGroup from "./components/customer-daily-sales-acc-to-age-group-sales";
import WeeklySalesAndPaymentDetail from "./components/weekly-sales-and-payment-detail";
import WeeklySalesDetail from "./components/weekly-sales-details";
import './totalling-management.css';

interface IProps{
  showShowPopup: boolean;
  showPopupToggleHandler: () => void;
}
const TotallingManagementonthly = ({showShowPopup, showPopupToggleHandler}: IProps) => {

  const { totallingManagementStore, masterManagementStore } = useStore();
  const {
    setMonthlyTotallingFilterDetail,
    resetMonthlyTotallingFilterDetail,
    monthlyTotallingFilter,
    GetWeeklySalesDetailCountService,
    resetWeeklySalesDetailCountState,
    weeklySalesDetailCountState,
    getMonthlySalesDetailCount,
    getCustomerSalesRatio,
    GetCustomerSalesRatioService,
    customerSalesRatioState,
    resetCustomerSalesRatioState,
    GetWeeklySalesAndPaymentDetailService,
    resetWeeklySalesAndPaymentDetailState,
    weeklySalesAndPaymentDetailState,
    getMonthlySalesAndPaymentDetail
  } = totallingManagementStore;
  const { GetAllStoreOptionService, getAllStoreOptionsAll, GetAllStaffOptionServiceByStoreId, getAllStaffOptionsWithSelectStaff, staffOptionsState } =
    masterManagementStore;
  const userType = getUserTypeFromLocalStorage();
  let storeId = getStoreIdFromLocalStorage() || 0;
  let headquarterId = getHeadquarterIdFromLocalStorage() || 0;

  const [storeIdSearch, setStoreIdSearch] = useState<number>(
    userType === userTypeEnum[userTypeEnum.Store] ? storeId : -1
  );

  const handleStoreIdSearch: ChangeEventHandler<HTMLSelectElement> =
    useCallback((event: ChangeEvent<HTMLSelectElement>) => {
      setStoreIdSearch(event.target.value as unknown as number);
    }, []);

  const callGetWeeklySalesDetailCountService = useCallback(() => {
    let firstDateOfMonth = dayjs(monthlyTotallingFilter.MonthYear, ).startOf("month").format(DATE_FORMAT);
    let lastDateOfMonth = dayjs(monthlyTotallingFilter.MonthYear, ).endOf("month").format(DATE_FORMAT);
    GetWeeklySalesDetailCountService(
      Number(storeIdSearch),
      headquarterId,
      monthlyTotallingFilter.StaffId,
      firstDateOfMonth,
      lastDateOfMonth
    );
    GetCustomerSalesRatioService(
      Number(storeIdSearch),
      headquarterId,
      monthlyTotallingFilter.StaffId,
      firstDateOfMonth,
      lastDateOfMonth
    );
  }, [
    GetWeeklySalesDetailCountService,
    GetCustomerSalesRatioService,
    storeIdSearch,
    headquarterId
  ]);

  const callGetWeeklySalesAndPaymentDetailService = useCallback(() => {
    let firstDateOfMonth = dayjs(monthlyTotallingFilter.MonthYear, ).startOf("month").format(DATE_FORMAT);
    let lastDateOfMonth = dayjs(monthlyTotallingFilter.MonthYear, ).endOf("month").format(DATE_FORMAT);
    if(showShowPopup)
      GetWeeklySalesAndPaymentDetailService(
        Number(storeIdSearch),
        headquarterId,
        monthlyTotallingFilter.StaffId,
        firstDateOfMonth,
        lastDateOfMonth
      );
  }, [
    GetWeeklySalesAndPaymentDetailService,
    storeIdSearch,
    headquarterId,
    showShowPopup
  ]);

  useEffect(() => {
    if (userType === userTypeEnum[userTypeEnum.HeadQuarter])
      GetAllStoreOptionService();
    return () => {
      resetWeeklySalesDetailCountState();
      resetMonthlyTotallingFilterDetail();
      resetWeeklySalesAndPaymentDetailState();
      resetCustomerSalesRatioState();
    };
  }, []);

  useEffect(() => {
    callGetWeeklySalesDetailCountService();
  }, [callGetWeeklySalesDetailCountService]);

  useEffect(() => {
    callGetWeeklySalesAndPaymentDetailService();
  }, [callGetWeeklySalesAndPaymentDetailService]);

  useEffect(() => {
    if(monthlyTotallingFilter.isFilterChanged){
      let firstDateOfMonth = dayjs(monthlyTotallingFilter.MonthYear, ).startOf("month").format(DATE_FORMAT);
      let lastDateOfMonth = dayjs(monthlyTotallingFilter.MonthYear, ).endOf("month").format(DATE_FORMAT);
      GetWeeklySalesDetailCountService(
        Number(storeIdSearch),
        headquarterId,
        monthlyTotallingFilter.StaffId,
        firstDateOfMonth,
        lastDateOfMonth
      );
      if(showShowPopup)
        GetWeeklySalesAndPaymentDetailService(
          Number(storeIdSearch),
          headquarterId,
          monthlyTotallingFilter.StaffId,
          lastDateOfMonth,
          lastDateOfMonth
        );
      GetCustomerSalesRatioService(
        Number(storeIdSearch),
        headquarterId,
        monthlyTotallingFilter.StaffId,
        firstDateOfMonth,
        lastDateOfMonth
      );
      setMonthlyTotallingFilterDetail({...monthlyTotallingFilter, isFilterChanged: false})
    }
  }, [monthlyTotallingFilter.isFilterChanged]);

  
  useEffect(() => {
    GetAllStaffOptionServiceByStoreId(storeIdSearch, false, userType === userTypeEnum[userTypeEnum.HeadQuarter] ? headquarterId : null);
  }, [storeIdSearch]);

  return (
    <>
      {(weeklySalesDetailCountState.inProgress ||
        staffOptionsState.inProgress ||
        customerSalesRatioState.inProgress ||
        weeklySalesAndPaymentDetailState.inProgress ||
        masterManagementStore.inProgress) && (
        <FormLoader
          loading={
            weeklySalesDetailCountState.inProgress ||
            staffOptionsState.inProgress ||
            customerSalesRatioState.inProgress ||
            weeklySalesAndPaymentDetailState.inProgress ||
            masterManagementStore.inProgress
          }
        />
      )}
      <div className="icon-nav navbar-fixed-top device-nav-bar userTopNav">
        <div className="row align-items-center">
          <div className="col-8">
            <div className="page_title_wrap">
              <h1 className="page_title">
                <FormattedMessage id="monthly_aggregate_sales" />
              </h1>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <FormattedMessage id="aggregate" />
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  <FormattedMessage id="monthly_sales" />
                </li>
              </ol>
            </div>
          </div>
          <div className="col-4">
            <ul className="add-list">
              <li>
                <LanguageSlider />
              </li>
              <li>
                {userType !== userTypeEnum[userTypeEnum.Store] && (
                  <>
                    {storeIdSearch && (
                      <div className="input-group">
                        <div className="input-group-text">
                          <span role="button" onClick={() => {}}>
                            <FontAwesomeIcon icon={faSearch} />
                          </span>
                        </div>
                        <DropdownInput
                          className="form-control"
                          placeholder={formatMessage("search_by_store_name")}
                          value={storeIdSearch}
                          onChange={(event)=>{
                            setMonthlyTotallingFilterDetail({...monthlyTotallingFilter, StaffId: -1});
                            handleStoreIdSearch(event)
                          }}
                          options={getAllStoreOptionsAll.map((option) => ({
                            label: option.value,
                            value: option.id,
                          }))}
                        />
                      </div>
                    )}
                  </>
                )}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="mt-4 mb-2">
        <Formik
          initialValues={_.omit(monthlyTotallingFilter,  ["isFilterChanged", "isFilterActive"])}
          enableReinitialize={true}
          validationSchema={monthLyTotallingFilterSchema}
          validateOnBlur={true}
          validateOnChange={true}
          onSubmit={async (values) => {
            let tempStaffId = typeof values.StaffId === "string" ? parseInt(values.StaffId) : values.StaffId;
            let tempValues = {
              MonthYear: values.MonthYear,
              StaffId: tempStaffId 
            };
            setMonthlyTotallingFilterDetail({
              ...tempValues,
              isFilterActive: true,
              isFilterChanged: true,
              showClear: _.isEqual({
                MonthYear: getEffectiveMonthYear(),
                StaffId: -1,
                showClear: false
              }, values) ? false : true

            });
          }}
        >
          {({ values }) => {
            return (
              <Form className="user-form p-0 ">
                <div className="row">
                  <div className="col-md-4 col-sm-6 col-12  form-group">
                    <Field
                      name="MonthYear"
                      as={FormikMonthYearFieldMUI}
                      disableFuture={true}
                    />
                  </div>
                  <div className="col-md-4 col-sm-6 col-12  form-group">
                    <Field
                      name="StaffId"
                      getData={false}
                      options={getAllStaffOptionsWithSelectStaff}
                      as={FormikFormSelect}
                    />
                  </div>
                  <div className="col-md-4 col-12  text-start">
                    <Button
                      type="submit"
                      // disabled={
                      //   _.isEqual(
                      //     _.omit(monthlyTotallingFilter, "isFilterActive"),
                      //     values
                      //   ) || weeklySalesDetailCountState.inProgress
                      // }
                      className="btn btn-primary"
                    >
                      <FormattedMessage id="apply" />
                    </Button>
                    {monthlyTotallingFilter.isFilterActive && monthlyTotallingFilter.showClear && (
                      <Button
                        type="button"
                        disabled={weeklySalesDetailCountState.inProgress}
                        className="ms-2"
                        variant="btn btn-secondary"
                        onClick={()=>{
                          setMonthlyTotallingFilterDetail({
                            MonthYear: getEffectiveMonthYear(),
                            StaffId: -1,
                            isFilterActive: false,
                            isFilterChanged: true,
                            showClear: false,
                          })
                        }}
                      >
                        <FormattedMessage id="clear" />
                      </Button>
                    )}
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
      <div className="totalling_tables_wrapper pb-4">
        <div className="mt-3">
          <div className="d-flex justify-content-between align-items-center">
            <h3 className="treatment_title">
              <FormattedMessage id="details_of_treatment_product_sales" />
            </h3>
            <Button
              type="button"
              onClick={showPopupToggleHandler}
              variant="btn btn-secondary"
            >
              <FormattedMessage id={showShowPopup ? "hide_details" : "show_details"} />
            </Button>
          </div>
          <WeeklySalesDetail data={getMonthlySalesDetailCount} />
        </div>
        <div className="mt-4">
          {
            showShowPopup &&
            <>
              <h3 className="treatment_title"><FormattedMessage id="all_day_reservations" /></h3>
              <WeeklySalesAndPaymentDetail data={getMonthlySalesAndPaymentDetail} />
            </>
          }
        </div>
        <div className="mt-4">
          <h3 className="treatment_title"><FormattedMessage id="by_gender_and_age_group" /></h3>
          <CustomerDailySalesAccToAgeGroup data={getCustomerSalesRatio} />
        </div>
      </div>
    </>
  );
};

export default ShowPopupHOC(observer(TotallingManagementonthly));
